import { useEffect, useState, useRef } from "react";
import RichTextEditor from "./richtext/RichTextEditor";
import { useParams, useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function EditPlan() {
    const [plan, setPlan] = useState(null);
    const [description, setDescription] = useState([]);
    const initialValue = useRef(null);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const navigate = useNavigate();

    const params = useParams();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPrivate.get(`/plans/${params.planId}`, {headers: {Authorization: "Bearer " + auth.accessToken}});
                initialValue.current = response.data.description;
                setPlan(response.data);
                setDescription(response.data.description);
            } catch (error) {
                console.error("Error fetching plans:", error);
            }
        };
        fetchData();
    }, [axiosPrivate, auth.accessToken, params.planId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            title: plan.title,
            mini_description: plan.mini_description,
            description: description
        };
        try {
            await axiosPrivate.put(`/plans/${params.planId}`, payload, {headers: {Authorization: "Bearer " + auth.accessToken}});
            navigate("/plans");
        } catch(err) {
            console.log(err);
        }
    }

    if (!plan) {
        return <div>Loading...</div>
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                id="title"
                autoComplete="off"
                onChange={(e) => setPlan(curr => ({...curr, title: e.target.value}))}
                value={plan.title}
                required
                placeholder="Title"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <input
                type="text"
                id="mini_description"
                autoComplete="off"
                value={plan.mini_description}
                onChange={(e) => setPlan(curr => ({...curr, mini_description: e.target.value}))}
                required
                placeholder="Mini Description"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <div className="pb-4">
                <RichTextEditor initialValue={initialValue.current} setValue={setDescription} />
            </div>
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
}

export default EditPlan;